/** Keep synchronous actions synchronous until a controller decision actually suspends their plan. */
export function deferredPlan<T>(value: T | Promise<T>): value is Promise<T> {
  return !!value && typeof (value as Promise<T>).then === 'function';
}
export function* awaitPlan<T>(plan: T | Promise<T>): Generator<Promise<unknown>, T, unknown> {
  return deferredPlan(plan) ? (yield plan) as T : plan;
}
export function resumePlan<T>(steps: Generator<Promise<unknown>, T, unknown>): T | Promise<T> {
  const advance = (value?: unknown, failed = false): T | Promise<T> => {
    const step = failed ? steps.throw(value) : steps.next(value);
    return step.done ? step.value : step.value.then(result => advance(result), error => advance(error, true));
  };
  return advance();
}
